export default __webpack_public_path__ + "static/media/plate-min.e642c114.png";